import script from "./edit-receipt-info.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-receipt-info.vue?vue&type=script&setup=true&lang=ts"

import "./edit-receipt-info.vue?vue&type=style&index=0&id=061f3d9e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-061f3d9e"]])

export default __exports__